<template>
    <div v-visibility-change="onVisibilityChange">
        <Spinner
                v-if="isLoading"
                v-bind:title="'Loading...' | trans">
        </Spinner>
        <MessageBox
                v-if="errorMessage !== null"
                v-bind:message="errorMessage"
                type="error">
        </MessageBox>

        <template v-for="(day, dayIndex) in days">
            <h4
                    v-if="dayIndex === 0 || $moment(day.date).date() === 1"
                    class="month-label">
                {{ $moment(day.date).format('MMMM') }}
            </h4>
            <Day
                    v-bind:key="day.date"
                    v-bind:day="day"
                    v-bind:firstDisplayedHour="firstDisplayedHour"
                    v-bind:lastDisplayedHour="lastDisplayedHour"
                    v-on:editDay="$emit('day:edit', day)"
            >
            </Day>
        </template>
    </div>
</template>

<script>
    // sadly, use of webpack resolve alias doesn't enable phpstorm link to source...
    import Day from './Day';
    import MessageBox from './MessageBox';
    import Spinner from '../Spinner';
	import ModalSmall from "../ModalSmall";

    export default {
        data() {
            return {
                days: null,
                errorMessage: null,
            }
        },
        methods: {
            async fetchDays() {
                this.days = null;
                this.errorMessage = null;
                try {
                    this.days = await this.$api.holiday.days();
                }
                catch (error) {
                    if (this.$api.is401(error)) {
                        // in case of 401, just abort javascript execution
                        return;
                    }
                    if (this.$api.isCancel(error)) {
                        // request canceled programmatically, let the new request do the job
                        return;
                    }
                    if (this.$api.isNoConnectivity(error)) {
                        this.errorMessage = this.$options.filters.trans('No connection ?');
                    } else {
                        this.$bugsnagClient.notify(error);
                        this.errorMessage = this.$options.filters.trans('Unknown error');
                    }
                }
            },
            async onVisibilityChange() {
                if (document.visibilityState === 'visible') {
                    await this.fetchDays();
                }
            },
        },
        computed: {
            isLoading() {
                return this.days === null && this.errorMessage === null;
            },
            firstDisplayedHour() {
                let firstDisplayedHour = 8;
                if (this.firstAvailableHour !== null) {
                    firstDisplayedHour = Math.min(8, this.firstAvailableHour - 1);
                }
                return firstDisplayedHour;
            },
            lastDisplayedHour() {
                let lastDisplayedHour = 20;
                if (this.lastAvailableHour !== null) {
                    lastDisplayedHour = Math.max(20, this.lastAvailableHour + 1);
                }
                return lastDisplayedHour;
            },
            firstAvailableHour() {
                const firstAvailableHourByDay = this.days
                    .map(
                        day => {
                            for (let hour = 0; hour < 24; hour++) {
                                if (day.hours[hour].available === true) {
                                    return hour;
                                }
                            }
                            return null;
                        }
                    )
                    .filter(hour => hour !== null)
                ;

                if (firstAvailableHourByDay.length === 0) {
                    return null;
                }
                return Math.min(...firstAvailableHourByDay);
            },
            lastAvailableHour() {
                const lastAvailableHourByDay = this.days
                    .map(
                        day => {
                            for (let hour = 23; hour >= 0; hour--) {
                                if (day.hours[hour].available === true) {
                                    return hour;
                                }
                            }
                            return null;
                        }
                    )
                    .filter(hour => hour !== null)
                ;

                if (lastAvailableHourByDay.length === 0) {
                    return null;
                }
                return Math.max(...lastAvailableHourByDay);
            }
        },
        async created() {
            await this.fetchDays();
        },
        components: {ModalSmall, MessageBox, Day, Spinner}
    }
</script>

<style>
    .month-label {
        background-color: #a2be3d;
        color: white;
        text-transform: uppercase;
        padding: 4px;
    }
</style>
